import { slice } from 'src/slices/routerTabSlices';

const setAccountTab = (params) => async (dispatch) => {
   dispatch(slice.actions.setAccountTab(params));
};

export const thunks = {
   setAccountTab,
};
